import React from 'react';
import { Box, Typography } from '@mui/material';

const getIcon = (type) => {
  if (type.startsWith('image/')) return null;
  if (type.startsWith('video/')) return '🎬';
  if (type === 'application/pdf') return '📄';
  if (type.startsWith('audio/')) return '🎵';
  if (type.includes('zip') || type.includes('rar')) return '🗜️';
  return '📁';
};

function FileThumbnail({ file, size = 56 }) {
  if (file.type && file.type.startsWith('image/') && file.thumbnail) {
    return (
      <Box sx={{ width: size, height: size, borderRadius: 2, overflow: 'hidden', bgcolor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={file.thumbnail} alt={file.fileName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </Box>
    );
  }
  return (
    <Box sx={{ width: size, height: size, borderRadius: 2, bgcolor: '#e3e3e3', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.7 }}>
      {getIcon(file.type || '')}
    </Box>
  );
}

export default FileThumbnail;
